
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function ServicesSection() {
  const { isVisible, setElementRef } = useScrollAnimation();
  const { t } = useTranslation();
  const [currentSlide1, setCurrentSlide1] = useState(0);
  const [currentSlide2, setCurrentSlide2] = useState(0);

  const slides1 = [
    'https://static.readdy.ai/image/c38ca4b43662e8df5be3570b092391f1/25cca6d2443bcc0d451a3cd90fcb34cf.png',
    'https://static.readdy.ai/image/c38ca4b43662e8df5be3570b092391f1/e90ac6fafbcabd1329ca25f5b901c7b5.png',
    'https://static.readdy.ai/image/c38ca4b43662e8df5be3570b092391f1/98c8da95042b329a60832793eff2ef06.png'
  ];

  const slides2 = [
    'https://static.readdy.ai/image/c38ca4b43662e8df5be3570b092391f1/78b42509474281a68dd32c2867886210.png',
    'https://static.readdy.ai/image/c38ca4b43662e8df5be3570b092391f1/b4f172afb0f0661a3fcb72c3c1a2a78b.png',
    'https://static.readdy.ai/image/c38ca4b43662e8df5be3570b092391f1/02fbca78737c3ff1f252eeec85550e7a.png'
  ];

  useEffect(() => {
    const slideInterval1 = setInterval(() => {
      setCurrentSlide1((prev) => (prev + 1) % slides1.length);
    }, 6000);
    return () => clearInterval(slideInterval1);
  }, [slides1.length]);

  useEffect(() => {
    const slideInterval2 = setInterval(() => {
      setCurrentSlide2((prev) => (prev + 1) % slides2.length);
    }, 6000);
    return () => clearInterval(slideInterval2);
  }, [slides2.length]);

  return (
    <section id="services" className="py-20 bg-white" ref={setElementRef}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-thin text-gray-900 mb-4">
            {t('services.title')}
          </h2>
        </div>

        <div className="space-y-24">
          <div
            className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            style={{ transitionDelay: '0ms' }}
          >
            <div className="grid md:grid-cols-2 gap-12 items-center ">
              <div className="">
                <div className="group relative">
                  <div className="relative rounded-2xl shadow-2xl overflow-hidden w-full h-[250px] md:h-[400px]">
                    {slides1.map((slide, index) => (
                      <img
                        key={index}
                        src={slide}
                        alt={`Service 1 - Slide ${index + 1}`}
                        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
                          index === currentSlide1 ? 'opacity-100' : 'opacity-0'
                        }`}
                      />
                    ))}
                  </div>
                  <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
                    {slides1.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentSlide1(index)}
                        className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                          index === currentSlide1
                            ? 'bg-white scale-110'
                            : 'bg-white/50 hover:bg-white/70'
                        }`}
                      />
                    ))}
                  </div>
                </div>
              </div>
              <div className="text-center">
                <div className="bg-stone-100 rounded-2xl p-8 mb-6">
                  <p className="text-stone-700 text-lg leading-relaxed">
                    {t('services.innovation.description')}
                  </p>
                </div>
                <a
                  href="https://youtu.be/qC8RulJcH50?si=M5JXAYzHnzjCbkoY"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-8 py-3 bg-stone-800 text-white rounded-full hover:bg-stone-700 transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  {t('services.service1.link')}
                  <i className="ri-external-link-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>

          <div
            className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            style={{ transitionDelay: '200ms' }}
          >
            <div className="grid md:grid-cols-2 gap-12 items-center md:flex-row-reverse">
              <div className="md:order-2">
                <div className="group relative">
                  <div className="relative rounded-2xl shadow-2xl overflow-hidden w-full h-[250px] md:h-[400px]">
                    {slides2.map((slide, index) => (
                      <img
                        key={index}
                        src={slide}
                        alt={`Service 2 - Slide ${index + 1}`}
                        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
                          index === currentSlide2 ? 'opacity-100' : 'opacity-0'
                        }`}
                      />
                    ))}
                  </div>
                  <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
                    {slides2.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentSlide2(index)}
                        className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                          index === currentSlide2
                            ? 'bg-white scale-110'
                            : 'bg-white/50 hover:bg-white/70'
                        }`}
                      />
                    ))}
                  </div>
                </div>
              </div>
              <div className="text-center">
                <div className="bg-stone-100 rounded-2xl p-8 mb-6">
                  <p className="text-stone-700 text-lg leading-relaxed">
                    {t('services.designTeam.description')}
                  </p>
                </div>
                <a
                  href="https://youtu.be/tLHV-Ai7ni4"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-8 py-3 bg-stone-800 text-white rounded-full hover:bg-stone-700 transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  {t('services.service2.link')}
                  <i className="ri-external-link-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
